export default __webpack_public_path__ + "static/media/attractions3.28ce46c0.png";